"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenSankeyMenuConfigurationLinks = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyLayout_1 = require("./SankeyLayout");
const types_1 = require("./types");
const prop_types_1 = __importDefault(require("prop-types"));
const SankeyUtils_1 = require("./SankeyUtils");
const d3 = __importStar(require("d3"));
const react_multi_select_component_1 = require("react-multi-select-component");
const fa_1 = require("react-icons/fa");
const SankeyMenuConfigurationLinksData_1 = require("./SankeyMenuConfigurationLinksData");
const SankeyMenuConfigurationLinksAppearence_1 = require("./SankeyMenuConfigurationLinksAppearence");
const SankeyMenuConfigurationLinksLabel_1 = require("./SankeyMenuConfigurationLinksLabel");
const SankeyMenuConfigurationLinksTags_1 = require("./SankeyMenuConfigurationLinksTags");
const SankeyMenuConfigurationLinksTooltip_1 = require("./SankeyMenuConfigurationLinksTooltip");
const SankeyDrawFunction_1 = require("./SankeyDrawFunction");
const SankeyMenuConfigurationLinksPropTypes = {
    t: prop_types_1.default.func.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    selected_link: prop_types_1.default.shape({ current: prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired }).isRequired,
    multi_selected_links: prop_types_1.default.shape({ current: prop_types_1.default.arrayOf(prop_types_1.default.shape(types_1.SankeyLinkPropTypes).isRequired).isRequired }).isRequired,
    menu_configuration_links: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired,
    style_editable: prop_types_1.default.bool.isRequired,
    set_displayed_value: prop_types_1.default.func.isRequired,
    tags_selected: prop_types_1.default.objectOf(prop_types_1.default.string.isRequired).isRequired,
    set_tags_selected: prop_types_1.default.func.isRequired,
    set_display_link_opacity: prop_types_1.default.func.isRequired,
};
const OpenSankeyMenuConfigurationLinks = (data, set_data, selected_link, multi_selected_links, t, tags_group_key, set_tags_group_key, tags_selected, set_tags_selected, additional_data_element, displayed_value, set_displayed_value, additional_link_appearence_items, display_link_opacity, set_display_link_opacity) => {
    const { fluxTags } = data;
    const ui = {
        'data': SankeyMenuConfigurationLinksData_1.SankeyMenuConfigurationLinksData(data, tags_selected, set_tags_selected, selected_link, multi_selected_links, set_data, t, additional_data_element, displayed_value, set_displayed_value),
        'appearence': SankeyMenuConfigurationLinksAppearence_1.SankeyMenuConfigurationLinksAppearence(data, selected_link, multi_selected_links, set_data, t, additional_link_appearence_items, false, 'default', display_link_opacity, set_display_link_opacity),
        'label': SankeyMenuConfigurationLinksLabel_1.SankeyMenuConfigurationLinksLabel(data, multi_selected_links, set_data, t, false, 'default'),
        'tooltip': SankeyMenuConfigurationLinksTooltip_1.SankeyMenuConfigurationLinksTooltip(data, set_data, selected_link, t)
    };
    if (Object.keys(fluxTags).length > 0 && data.accordeonToShow.includes('EF')) {
        ui['tags'] = SankeyMenuConfigurationLinksTags_1.SankeyMenuConfigurationLinksTags(data, multi_selected_links, set_data, tags_group_key, set_tags_group_key, tags_selected, set_tags_selected, t);
    }
    return ui;
};
exports.OpenSankeyMenuConfigurationLinks = OpenSankeyMenuConfigurationLinks;
const SankeyMenuConfigurationLinks = ({ t, data, set_data, selected_link, multi_selected_links, menu_configuration_links, style_editable, set_displayed_value, tags_selected, set_tags_selected, set_display_link_opacity }) => {
    const { fluxTags, dataTags } = data;
    const [style_to_apply_to_link, set_style_to_apply_to_link] = react_1.useState('default');
    const [tags_group_key, set_tags_group_key] = react_1.useState(Object.keys(fluxTags).length > 0 ? Object.keys(fluxTags)[0] : '');
    const set_show_link = react_1.useState(true)[1];
    if ((tags_group_key == '' && Object.keys(fluxTags).length > 0) || (!Object.keys(fluxTags).includes(tags_group_key) && Object.keys(fluxTags).length > 0)) {
        set_tags_group_key(Object.keys(fluxTags)[0]);
    }
    let link = selected_link.current;
    if (link === undefined) {
        link = SankeyUtils_1.default_link(data);
    }
    const newEntries = new Map(Object.entries(dataTags).map(([dataTagKey, dataTag]) => {
        return (Object.keys(dataTag.tags).length > 0) ? [
            dataTagKey,
            Object.entries(dataTag.tags).filter(tag => tag[1].selected).length > 0 ? Object.entries(dataTag.tags).filter(tag => tag[1].selected)[0][0] : Object.keys(dataTag.tags)[0]
        ] : ['n', 'n'];
    }));
    //Créer un objet contenant la clé de chaque dataTag avec pour valeur la première tag de ces groupe
    const dataTagsSelected = Object.fromEntries(newEntries);
    //supprime les groupe tag qui n'ont pas de tag car on ne peux pas choisir de tags pour affecter une valeur au flux
    delete dataTagsSelected['n'];
    if (Object.keys(tags_selected).length !== Object.keys(dataTagsSelected).length) {
        set_tags_selected(dataTagsSelected);
    }
    const INITIAL_OPTIONS_LINKS = Object.values(data.links).filter(l => (data.displayed_link_selector) ? (data.nodes[l.idSource].display && data.nodes[l.idTarget].display) : true).map((d) => { return { 'label': (data.nodes[d.idSource].name + '--->' + data.nodes[d.idTarget].name), 'value': d.idLink }; });
    const selected_links = multi_selected_links.current.map((d) => {
        if (data.nodes[d.idSource] == undefined || data.nodes[d.idTarget] == undefined) {
            return;
        }
        return { 'label': (data.nodes[d.idSource].name + '--->' + data.nodes[d.idTarget].name), 'value': d.idLink };
    });
    //Renvoie le menue déroulant pour la sélection des flux
    const dropdownMultiLinks = () => {
        const DD = (react_1.default.createElement("div", { id: 'DD_multi_links' },
            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { valueRenderer: (selected) => {
                    return selected.filter(d => d !== undefined).length ? selected.map(({ label }) => label + ', ') : 'Aucun flux sélectionné';
                }, options: INITIAL_OPTIONS_LINKS, value: selected_links, overrideStrings: {
                    'selectAll': 'Tout sélectionner',
                }, onChange: (selected) => {
                    const new_sel = selected.map(d => d.value);
                    const m_s = Object.values(data.links).filter(d => (new_sel.includes(d.idLink)));
                    multi_selected_links.current = m_s;
                    set_display_link_opacity(m_s[0].opacity);
                    Object.values(data.links).forEach(l => {
                        d3.selectAll(' .opensankey #gg_' + l.idLink + ' rect').attr('fill-opacity', '0');
                        d3.selectAll(' .opensankey #gg_' + l.idLink + ' .drag_zone').attr('stroke-opacity', '0');
                    });
                    multi_selected_links.current.forEach(l => {
                        const sel = d3.selectAll(' .opensankey #gg_' + l.idLink + ' rect');
                        sel.attr('fill-opacity', '1');
                        d3.selectAll(' .opensankey #gg_' + l.idLink + ' .drag_zone').attr('stroke-opacity', '1');
                    });
                    if (multi_selected_links.current.length > 0) {
                        let new_tags_selected = tags_selected;
                        if (multi_selected_links.current[0].idLink.includes('_')) {
                            const index_grp_tag = multi_selected_links.current[0].idLink.split('_');
                            // Supprime le première élément du tableau qui ne contient que l'id du flux
                            index_grp_tag.shift();
                            new_tags_selected = {};
                            // On fabrique un tags_selected pour récupérer la bonne valeur pour value_selected_parameter
                            for (const i in index_grp_tag) {
                                const key = Object.keys(data.dataTags)[Number(i)];
                                new_tags_selected[key] = Object.keys(Object.values(data.dataTags)[Number(i)].tags)[Number(index_grp_tag[i])];
                            }
                            set_tags_selected(new_tags_selected);
                            set_displayed_value(SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, new_tags_selected).value);
                        }
                        else if (Object.values(data.dataTags).length > 0) {
                            // Dans le cas où il n'y a pas de '_' ce qui implique que les datatags sont en mode selection simple
                            const tmp = [];
                            Object.values(data.dataTags).forEach(dt => {
                                tmp.push(Object.entries(dt.tags).filter(t => t[1].selected)[0][0]);
                            });
                            const n_t_s = {};
                            Object.keys(data.dataTags).forEach((dt, i) => {
                                n_t_s[dt] = tmp[i];
                            });
                            set_displayed_value(SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, n_t_s).value);
                        }
                        else {
                            set_displayed_value(SankeyDrawFunction_1.value_selected_parameter(data, multi_selected_links, new_tags_selected).value);
                        }
                    }
                    set_data(Object.assign({}, data));
                }, labelledBy: 'hello' })));
        return DD;
    };
    //Dépalce la place des flux sélectionnés vers le début dans le tableau de flux de data
    //Permet donc de les déssiner avant
    const handleUpLink = (i) => {
        const { links } = data;
        const listElmt = Object.keys(links);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt - 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = links[elt];
        });
        for (const member in links)
            delete links[member];
        Object.assign(links, new_cat);
        set_data(Object.assign({}, data));
    };
    //Dépalce la place des flux sélectionnés vers la fin dans le tableau de flux de data
    //Permet donc de les déssiner après
    const handleDownLink = (i) => {
        const { links } = data;
        const listElmt = Object.keys(links);
        const posElemt = listElmt.indexOf(i);
        listElmt.splice(posElemt, 1);
        listElmt.splice(posElemt + 1, 0, i);
        const new_cat = {};
        listElmt.forEach(elt => {
            new_cat[elt] = links[elt];
        });
        for (const member in links)
            delete links[member];
        Object.assign(links, new_cat);
        set_data(Object.assign({}, data));
    };
    //Add new link and selection it
    const add_new_link = () => {
        const { nodes, links } = data;
        if (Object.keys(nodes).length < 2) {
            return;
        }
        const link = SankeyUtils_1.default_link(data);
        // Méthode pour incrementer idNode
        const listId = [];
        Object.keys(data.links).forEach(elt => listId.push(Number(elt.replace('link', ''))));
        const idLink = listId.length > 0 ? Math.max(...listId) + 1 : 0;
        link.idLink = 'link' + idLink;
        links[link.idLink] = link;
        const node_keys = Object.keys(nodes);
        link.idSource = nodes[node_keys[0]].idNode;
        link.idTarget = nodes[node_keys[1]].idNode;
        if (link.idSource === link.idTarget) {
            link.recycling = true;
        }
        nodes[node_keys[0]].outputLinksId.push(link.idLink);
        nodes[node_keys[1]].inputLinksId.push(link.idLink);
        selected_link.current = link;
        multi_selected_links.current = [link];
        set_display_link_opacity(link.opacity);
        set_data(Object.assign({}, data));
        set_show_link(true);
    };
    //Change the source of selected link
    const source_change = (changeEvent) => {
        const link = multi_selected_links.current[0];
        //Causait un problème d'acumulation de la valeur de des differents link sur des noeuds non associé
        const previous_node = data.nodes[link.idSource];
        previous_node.outputLinksId.splice(previous_node.outputLinksId.indexOf(multi_selected_links.current[0].idLink), 1);
        const source_node = data.nodes[changeEvent.target.value];
        link.idSource = source_node.idNode;
        if (link.idSource === link.idTarget) {
            link.recycling = true;
        }
        source_node.outputLinksId.push(multi_selected_links.current[0].idLink);
        set_data(Object.assign({}, data));
    };
    const addDropSource = () => {
        if (Object.keys(data.nodes).length >= 2 && Object.keys(data.links).length != 0 && multi_selected_links.current.length != 0) {
            return (Object.values(data.nodes).map((n, i) => react_1.default.createElement("option", { key: i, value: n.idNode }, n.name)));
        }
    };
    const addDropCible = () => {
        if (Object.keys(data.nodes).length >= 2 && Object.keys(data.links).length != 0 && multi_selected_links.current.length != 0) {
            return (Object.values(data.nodes).map((n, i) => react_1.default.createElement("option", { key: i, value: n.idNode }, n.name)));
        }
    };
    //Change the target of selected link
    const target_change = (changeEvent) => {
        const { nodes } = data;
        const link = multi_selected_links.current[0];
        const previous_node = nodes[link.idTarget];
        previous_node.inputLinksId.splice(previous_node.inputLinksId.indexOf(multi_selected_links.current[0].idLink), 1);
        const target_node = nodes[changeEvent.target.value];
        link.idTarget = target_node.idNode;
        if (link.idSource === link.idTarget) {
            link.recycling = true;
        }
        target_node.inputLinksId.push(multi_selected_links.current[0].idLink);
        set_data(Object.assign({}, data));
    };
    const apply_style_to_selected_links = () => {
        const style = data.style_link[style_to_apply_to_link];
        multi_selected_links.current.map(d => {
            // type of link
            d.recycling = style.recycling;
            d.orientation = style.orientation;
            d.arrow = style.arrow;
            // display_attribute
            d.label_position = style.label_position;
            d.orthogonal_label_position = style.orthogonal_label_position;
            d.label_on_path = style.label_on_path;
            d.label_visible = style.label_visible;
            d.text_color = style.text_color;
            d.color = style.color;
            d.curvature = style.curvature;
            d.curved = style.curved;
        });
    };
    //Change le style des flux sélectionnés
    const style_of_selected_links = () => {
        let style_to_display = 'Aucun';
        if (multi_selected_links.current.length != 0) {
            style_to_display = multi_selected_links.current[0].style;
            let inchangee = true;
            multi_selected_links.current.map(d => {
                inchangee = (d.style == style_to_display) ? inchangee : false;
            });
            if (style_to_display != '' && style_to_display !== undefined) {
                return (inchangee) ? SankeyUtils_1.cut_name(data.style_link[style_to_display].idLink, 25) : 'Multiple style parmi les noeuds sélectionnés';
            }
            else {
                return 'Aucun';
            }
        }
        else {
            return style_to_display;
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { justifyContent: 'center', marginBottom: '5px' } },
            react_1.default.createElement("b", null, t('Flux.pg'))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.pdl'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 8 },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { value: data.display_style.link_font_family_selected, onChange: (evt) => {
                        data.display_style.link_font_family_selected = evt.target.value;
                        set_data(Object.assign({}, data));
                    } }, data.display_style.font_family.map((d) => {
                    return react_1.default.createElement("option", { style: { fontFamily: d }, key: 'ff-' + d, value: d }, d);
                })))),
        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { justifyContent: 'center', marginTop: '20px', marginBottom: '5px' } },
            react_1.default.createElement("b", null, t('Flux.pl'))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.plus', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.plus' },
                        t('Menu.tooltips.flux.plus'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "success", onClick: () => {
                            add_new_link();
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(fa_1.FaPlus, null)))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.slct', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.slct' },
                        t('Menu.tooltips.flux.slct'),
                        " ") }, dropdownMultiLinks())),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.rm', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.rm' },
                        t('Menu.tooltips.flux.rm'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "danger-right", onClick: () => {
                            multi_selected_links.current.forEach(l => SankeyUtils_1.delete_link(data, l));
                            multi_selected_links.current = [];
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(fa_1.FaMinus, null))))),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.dls', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.dls' },
                        t('Menu.tooltips.flux.dls'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.displayed_link_selector, onChange: evt => {
                            // const c=evt.target.checkeds
                            data.displayed_link_selector = evt.target.checked;
                            set_data(Object.assign({}, data));
                        } }))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 11 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Menu.dls')))),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.src'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.src', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.src' },
                        t('Flux.tooltips.src'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { disabled: multi_selected_links.current.length != 1, onChange: source_change, value: (multi_selected_links.current.length > 0) ? multi_selected_links.current[0].idSource : '' }, addDropSource())))),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.trgt'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.trgt', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.trgt' },
                        t('Flux.tooltips.trgt'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { disabled: multi_selected_links.current.length != 1, onChange: target_change, value: (multi_selected_links.current.length > 0) ? multi_selected_links.current[0].idTarget : '' }, addDropCible())))),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.if'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.if', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.if' },
                        t('Flux.tooltips.if'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', onClick: () => {
                            const nodes_to_reorganize = [];
                            multi_selected_links.current.forEach(l => {
                                const tmp = l.idSource;
                                const previous_node_s = data.nodes[l.idSource];
                                previous_node_s.outputLinksId.splice(previous_node_s.outputLinksId.indexOf(l.idLink), 1);
                                const source_node = data.nodes[l.idTarget];
                                l.idSource = source_node.idNode;
                                source_node.outputLinksId.push(l.idLink);
                                nodes_to_reorganize.push(source_node);
                                const previous_node_t = data.nodes[l.idTarget];
                                previous_node_t.inputLinksId.splice(previous_node_t.inputLinksId.indexOf(l.idLink), 1);
                                const target_node = data.nodes[tmp];
                                l.idTarget = target_node.idNode;
                                target_node.inputLinksId.push(l.idLink);
                                nodes_to_reorganize.push(target_node);
                            });
                            nodes_to_reorganize.forEach(n => {
                                SankeyLayout_1.reorganize_inputLinksId(n, true, true, data.nodes, data.links);
                            });
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(fa_1.FaArrowsAltH, null))))),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Flux.dzf'))),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.up', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.up' },
                            t('Flux.tooltips.up'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', disabled: multi_selected_links.current.length != 1, onClick: () => {
                                multi_selected_links.current.map(l => {
                                    handleDownLink(l.idLink);
                                });
                            } },
                            react_1.default.createElement(fa_1.FaAngleUp, null))),
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.upup', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.upup' },
                            t('Flux.tooltips.upup'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', disabled: multi_selected_links.current.length != 1, onClick: () => {
                                multi_selected_links.current.map(l => {
                                    const i = l.idLink;
                                    const { links } = data;
                                    const listElmt = Object.keys(links);
                                    const posElemt = listElmt.indexOf(i);
                                    listElmt.splice(posElemt, 1);
                                    listElmt.splice(listElmt.length, 0, i);
                                    const new_cat = {};
                                    listElmt.forEach(elt => {
                                        new_cat[elt] = links[elt];
                                    });
                                    for (const member in links)
                                        delete links[member];
                                    Object.assign(links, new_cat);
                                });
                                set_data(Object.assign({}, data));
                            } },
                            react_1.default.createElement(fa_1.FaAngleDoubleUp, null))),
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.dwn', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.dwn' },
                            t('Flux.tooltips.dwn'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'warning', disabled: multi_selected_links.current.length != 1, onClick: () => {
                                multi_selected_links.current.map(l => {
                                    handleUpLink(l.idLink);
                                });
                            } },
                            react_1.default.createElement(fa_1.FaAngleDown, null))),
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.dwndwn', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.dwndwn' },
                            t('Flux.tooltips.dwndwn'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'warning', disabled: multi_selected_links.current.length != 1, onClick: () => {
                                multi_selected_links.current.map(l => {
                                    const i = l.idLink;
                                    const { links } = data;
                                    const listElmt = Object.keys(links);
                                    const posElemt = listElmt.indexOf(i);
                                    listElmt.splice(posElemt, 1);
                                    listElmt.splice(0, 0, i);
                                    const new_cat = {};
                                    listElmt.forEach(elt => {
                                        new_cat[elt] = links[elt];
                                    });
                                    for (const member in links)
                                        delete links[member];
                                    Object.assign(links, new_cat);
                                });
                                set_data(Object.assign({}, data));
                            } },
                            react_1.default.createElement(fa_1.FaAngleDoubleDown, null)))))),
        react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                    t('Flux.style'),
                    ":")),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 }, (style_editable) ? react_1.default.createElement(react_bootstrap_1.Dropdown, null,
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "success", id: "dropdown-basic" }, style_of_selected_links()),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                            set_style_to_apply_to_link('');
                            multi_selected_links.current.map(n => {
                                n.style = '';
                            });
                            set_data(Object.assign({}, data));
                        } }, 'Aucun'),
                    Object.keys(data.style_link).map((d, i) => {
                        return (react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { key: i, onClick: () => {
                                set_style_to_apply_to_link(d);
                                multi_selected_links.current.map(n => {
                                    n.style = d;
                                });
                                set_data(Object.assign({}, data));
                            } }, data.style_link[d].idLink));
                    }))) : react_1.default.createElement(react_bootstrap_1.Form.Label, null, style_of_selected_links())),
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Menu.tooltips.flux.as', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Menu.tooltips.flux.as' },
                        t('Flux.tooltips.as'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: 'info', onClick: () => {
                            apply_style_to_selected_links();
                            set_data(Object.assign({}, data));
                        } }, t('Flux.as'))))),
        (multi_selected_links.current.length !== 0) ? (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
            react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
                react_1.default.createElement(react_bootstrap_1.Tabs, { defaultActiveKey: "flux_data", id: "settings-layout", fill: true }, menu_configuration_links)))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
SankeyMenuConfigurationLinks.propTypes = SankeyMenuConfigurationLinksPropTypes;
exports.default = SankeyMenuConfigurationLinks;
